export const SITE_ORIGIN = 'https://passionofaroma.com';
export const LOGO_SRC = `${process.env.PUBLIC_URL}/logo.png`;
export const LOGO_ABSOLUTE_URL = `${SITE_ORIGIN}${process.env.PUBLIC_URL || ''}/logo.png`;
